<template>
  <div class="lpr-root">

    <!-- Navbar -->
    <header class="lpr-navbar" :class="{ 'lpr-navbar--scrolled': scrolled }">
      <div class="lpr-container lpr-navbar__inner">
        <router-link to="/">
          <img src="@/assets/images/logo/mexico_verde2.png" alt="Portal México Verde" class="lpr-navbar__logo" />
        </router-link>
        <nav class="lpr-navbar__right">
          <router-link to="/" class="lpr-link-back">← Inicio</router-link>
          <router-link to="/auth/login" class="lpr-btn lpr-btn--outline">Ingresar</router-link>
          <router-link to="/auth/register" class="lpr-btn lpr-btn--primary">Registrarse</router-link>
        </nav>
      </div>
    </header>

    <!-- Hero con el resultado -->
    <section class="lpr-hero" v-if="resultado">
      <div class="lpr-container lpr-hero__inner">
        <div class="lpr-result-card">
          <div class="lpr-result-card__badge">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
            </svg>
          </div>
          <p class="lpr-result-card__label">Tu nivel de reverdecimiento</p>
          <h1 class="lpr-result-card__nivel">{{ resultado.nivel }}</h1>
          <div class="lpr-result-card__score">
            <span class="lpr-score-badge">{{ resultado.total }} pts</span>
          </div>
          <div class="lpr-result-card__bar">
            <div class="lpr-result-card__bar-fill" :style="{ width: progresoWidth }"></div>
          </div>
          <p class="lpr-result-card__folio">Folio de diagnóstico: <strong>#{{ resultado.respuesta_id }}</strong></p>
          <div class="lpr-result-card__actions">
            <router-link to="/diagnostico" class="lpr-btn lpr-btn--ghost">↩ Repetir diagnóstico</router-link>
            <router-link to="/auth/register" class="lpr-btn lpr-btn--primary lpr-btn--lg">Crear cuenta gratuita →</router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Sin datos -->
    <section class="lpr-hero" v-else>
      <div class="lpr-container lpr-hero__inner">
        <div class="lpr-result-card lpr-result-card--empty">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.5)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <p>No se encontraron datos del resultado. Por favor vuelve a realizar el diagnóstico.</p>
          <router-link to="/diagnostico" class="lpr-btn lpr-btn--primary">Ir al diagnóstico</router-link>
        </div>
      </div>
    </section>

    <!-- Sección de registro -->
    <section class="lpr-cta" v-if="resultado">
      <div class="lpr-container lpr-cta__inner">
        <div class="lpr-cta__text">
          <span class="lpr-eyebrow">Siguiente paso</span>
          <h2>Accede a tu hoja de ruta personalizada</h2>
          <p>
            Crea tu cuenta gratuita en Portal México Verde y obtén acceso a herramientas
            de planeación, directorios de servicios verdes y programas de apoyo diseñados
            para empresas en tu nivel de madurez.
          </p>
          <ul class="lpr-cta__list">
            <li>Hoja de ruta adaptada a tu nivel: <strong>{{ resultado?.nivel }}</strong></li>
            <li>Directorio de proveedores y servicios verdes</li>
            <li>Biblioteca técnica y normativa ambiental</li>
            <li>Acceso a programas de financiamiento verde</li>
          </ul>
        </div>
        <div class="lpr-cta__actions">
          <router-link to="/auth/register" class="lpr-btn lpr-btn--primary lpr-btn--lg">Crear cuenta gratuita →</router-link>
          <router-link to="/auth/login" class="lpr-btn lpr-btn--outline-dark">Ya tengo cuenta</router-link>
        </div>
      </div>
    </section>

    <!-- Footer mínimo -->
    <footer class="lpr-footer">
      <div class="lpr-container lpr-footer__inner">
        <span>© {{ currentYear }} Portal México Verde · AMSDE. Todos los derechos reservados.</span>
        <div class="lpr-footer__links">
          <router-link to="/">Inicio</router-link>
          <router-link to="/auth/register">Registrarse</router-link>
          <router-link to="/auth/login">Ingresar</router-link>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
export default {
  name: "DiagnosticoResultadoPublico",

  data() {
    return {
      resultado: null,
      scrolled: false,
      currentYear: new Date().getFullYear(),
    };
  },

  computed: {
    progresoWidth() {
      if (!this.resultado) return "0%";
      return Math.min(100, Math.round((this.resultado.total / 100) * 100)) + "%";
    },
  },

  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },

  created() {
    const raw = sessionStorage.getItem("diagnostico_resultado");
    if (raw) {
      try {
        this.resultado = JSON.parse(raw);
      } catch {
        this.resultado = null;
      }
    }
  },

  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 40;
    },
  },
};
</script>

<style scoped>
/* ── Base ───────────────────────────────────────────────────────────────── */
.lpr-root {
  font-family: 'Segoe UI', system-ui, sans-serif;
  color: #1a1a2e; min-height: 100vh; display: flex; flex-direction: column;
}
.lpr-container { max-width: 900px; margin: 0 auto; padding: 0 1.5rem; }

/* ── Buttons ────────────────────────────────────────────────────────────── */
.lpr-btn {
  display: inline-flex; align-items: center; gap: .4rem;
  padding: .6rem 1.4rem; border-radius: 4px; font-weight: 600;
  font-size: .9rem; text-decoration: none; transition: all .2s;
  border: 2px solid transparent; cursor: pointer;
}
.lpr-btn--primary         { background: #AF1F23; color: #fff; border-color: #AF1F23; }
.lpr-btn--primary:hover   { background: #8e1519; border-color: #8e1519; }
.lpr-btn--ghost           { background: rgba(255,255,255,.12); color: #fff; border-color: rgba(255,255,255,.35); }
.lpr-btn--ghost:hover     { background: rgba(255,255,255,.22); }
.lpr-btn--outline         { background: transparent; color: #fff; border-color: rgba(255,255,255,.6); }
.lpr-btn--outline:hover   { background: rgba(255,255,255,.12); }
.lpr-btn--outline-dark    { background: transparent; color: #09377c; border-color: #09377c; }
.lpr-btn--outline-dark:hover { background: #09377c; color: #fff; }
.lpr-btn--lg              { padding: .85rem 2.25rem; font-size: 1rem; }

/* ── Navbar ─────────────────────────────────────────────────────────────── */
.lpr-navbar {
  position: fixed; top: 0; left: 0; right: 0; z-index: 1000;
  background: transparent; transition: background .3s, box-shadow .3s;
}
.lpr-navbar--scrolled { background: #09377c; box-shadow: 0 2px 16px rgba(0,0,0,.25); }
.lpr-navbar__inner {
  display: flex; align-items: center; justify-content: space-between;
  height: 68px; max-width: 1140px;
}
.lpr-navbar__logo { height: 34px; object-fit: contain; filter: brightness(0) invert(1); }
.lpr-navbar__right { display: flex; align-items: center; gap: 1rem; }
.lpr-link-back { color: rgba(255,255,255,.75); font-size: .88rem; text-decoration: none; transition: color .2s; }
.lpr-link-back:hover { color: #fff; }

/* ── Hero ───────────────────────────────────────────────────────────────── */
.lpr-hero {
  background: linear-gradient(135deg, #071628 0%, #0b2a1a 100%);
  min-height: 60vh; display: flex; align-items: center;
  padding: 6rem 0 4rem;
}
.lpr-hero__inner { width: 100%; }

/* ── Result card ────────────────────────────────────────────────────────── */
.lpr-result-card {
  max-width: 560px; margin: 0 auto; text-align: center;
  background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.12);
  border-radius: 16px; padding: 3rem 2.5rem;
}
.lpr-result-card--empty { color: rgba(255,255,255,.6); display: flex; flex-direction: column; align-items: center; gap: 1.25rem; }
.lpr-result-card__badge {
  width: 72px; height: 72px; background: rgba(175,31,35,.2);
  border: 2px solid rgba(175,31,35,.4); border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1.5rem;
}
.lpr-result-card__badge svg { width: 36px; height: 36px; stroke: #ef9a9a; }
.lpr-result-card__label { color: rgba(255,255,255,.55); font-size: .85rem; text-transform: uppercase; letter-spacing: .1em; margin: 0 0 .5rem; }
.lpr-result-card__nivel { color: #fff; font-size: clamp(1.6rem, 4vw, 2.2rem); font-weight: 800; margin: 0 0 1.25rem; }
.lpr-result-card__score { margin-bottom: 1.25rem; }
.lpr-score-badge {
  display: inline-block; background: #AF1F23; color: #fff;
  font-weight: 700; font-size: 1.1rem; padding: .4rem 1.25rem;
  border-radius: 20px;
}
.lpr-result-card__bar {
  height: 10px; background: rgba(255,255,255,.1); border-radius: 5px;
  overflow: hidden; margin-bottom: 1.25rem;
}
.lpr-result-card__bar-fill {
  height: 100%; border-radius: 5px;
  background: linear-gradient(90deg, #388e3c, #66bb6a);
  transition: width .8s ease;
}
.lpr-result-card__folio { color: rgba(255,255,255,.4); font-size: .8rem; margin: 0 0 2rem; }
.lpr-result-card__actions { display: flex; gap: 1rem; justify-content: center; flex-wrap: wrap; }

/* ── CTA section ────────────────────────────────────────────────────────── */
.lpr-cta { background: #f5f7fa; padding: 5rem 0; }
.lpr-cta__inner {
  display: grid; grid-template-columns: 1fr auto; gap: 3rem; align-items: center;
  max-width: 900px;
}
.lpr-eyebrow {
  display: block; text-transform: uppercase; letter-spacing: .12em;
  font-size: .75rem; font-weight: 700; color: #AF1F23; margin-bottom: .5rem;
}
.lpr-cta__text h2 { font-size: clamp(1.4rem, 3vw, 1.9rem); font-weight: 700; margin: .4rem 0 1rem; color: #0b1f3a; }
.lpr-cta__text p  { color: #555; line-height: 1.7; margin-bottom: 1.25rem; }
.lpr-cta__list { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: .5rem; }
.lpr-cta__list li { font-size: .9rem; color: #444; padding-left: 1.2rem; position: relative; }
.lpr-cta__list li::before { content: '✓'; position: absolute; left: 0; color: #2e7d32; font-weight: 700; }
.lpr-cta__actions { display: flex; flex-direction: column; gap: 1rem; align-items: center; flex-shrink: 0; }

/* ── Footer ─────────────────────────────────────────────────────────────── */
.lpr-footer { background: #0b1f3a; padding: 1.5rem 0; margin-top: auto; }
.lpr-footer__inner {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 1rem; max-width: 1140px;
}
.lpr-footer__inner > span { color: rgba(255,255,255,.35); font-size: .8rem; }
.lpr-footer__links { display: flex; gap: 1.5rem; }
.lpr-footer__links a { color: rgba(255,255,255,.5); font-size: .82rem; text-decoration: none; transition: color .2s; }
.lpr-footer__links a:hover { color: #fff; }

/* ── Responsive ─────────────────────────────────────────────────────────── */
@media (max-width: 700px) {
  .lpr-cta__inner { grid-template-columns: 1fr; }
  .lpr-cta__actions { flex-direction: row; flex-wrap: wrap; justify-content: flex-start; }
  .lpr-result-card { padding: 2rem 1.5rem; }
  .lpr-navbar__right .lpr-btn { display: none; }
}
</style>
